const CONSTANT = {
  site: {
    name: 'Hipotecario Seguros'
  },
  header: {
    position: 'fixed', // fixed, absolute, sticky, static or relative
    color: 'default' // primary, secondary or default
  },
  sidebar: {
    width: 240
  },
  categories: {
    level: {
      hidden: 0,
      primary: 1,
      secondary: 2,
      tertiary: 3
    },
    objetive: {
      secondary: 1,
      link: 2,
      page: 3,
      url: 4,
      iframe: 5
    }
  }
};

export default CONSTANT;
